/**
 * Onboarding Configuration
 * 
 * Defines the sequence of onboarding screens and their layout behavior.
 * Layout hints allow OnboardingContainer to drive UI visibility
 * from config rather than scattered hardcoded index checks.
 */
export const ONBOARDING_CONFIG = [
  { 
    id: 'hero', 
    title: 'Welcome to VerbalFlo',
    // Screen 1 manages its own CTA and has no back button
    hideLayoutBack: true,
    hideLayoutCTA: true,
    fullScreen: true,
  },
  { 
    id: 'problem', 
    title: 'Why VerbalFlo?',
    // Screen 2 manages its own CTA
    hideLayoutCTA: true,
  },
  { 
    id: 'game-based', 
    title: 'Game-Based Learning',
    // Screen 3 manages its own CTA
    hideLayoutCTA: true,
  },
  { 
    id: 'daily-reps', 
    title: 'Small Daily Reps',
    // Screen 4 manages its own CTA
    hideLayoutCTA: true,
  },
  { 
    id: 'auth', 
    title: 'Create Account',
    // Auth screen manages its own CTA
    hideLayoutCTA: true,
  },
  { 
    id: 'goal', 
    title: 'Set Your Goal',
    // Goal screen manages its own CTA (disabled state)
    hideLayoutCTA: true,
  },
  { 
    id: 'commitment', 
    title: 'Your Commitment',
    hideLayoutCTA: true,
  },
  {
    id: 'summary',
    title: 'Ready to Progress',
    hideLayoutCTA: true,
  },
];

/**
 * DEVELOPMENT FLAGS
 * Set BYPASS_ONBOARDING_AUTH to true to skip the forced Google sign-in after screen 4.
 * This is for UI design convenience and does not affect Screen 1 optional sign-in.
 */
export const BYPASS_ONBOARDING_AUTH = true;

